/**
 * Enregistrement du service worker (mode hors-ligne).
 * Jamais actif en développement ni dans l'aperçu Lovable.
 */

const SW_URL = "/sw.js";

function isRefusedContext(): boolean {
  if (typeof window === "undefined") return true;
  if (!import.meta.env.PROD) return true;
  if (window.self !== window.top) return true;

  const host = window.location.hostname;
  if (host.startsWith("id-preview--") || host.startsWith("preview--")) return true;
  if (host === "lovableproject.com" || host.endsWith(".lovableproject.com")) return true;
  if (host === "lovableproject-dev.com" || host.endsWith(".lovableproject-dev.com")) return true;
  if (host === "beta.lovable.dev" || host.endsWith(".beta.lovable.dev")) return true;
  if (new URLSearchParams(window.location.search).get("sw") === "off") return true;

  return false;
}

async function unregisterAppServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations
        .filter((registration) => {
          const url = registration.active?.scriptURL || registration.waiting?.scriptURL || registration.installing?.scriptURL || "";
          return url.endsWith(SW_URL);
        })
        .map((registration) => registration.unregister())
    );
  } catch (error) {
    console.warn("[PWA] Unregister failed:", error);
  }
}

export async function registerAppServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  if (isRefusedContext()) {
    await unregisterAppServiceWorkers();
    return;
  }

  try {
    // @ts-ignore virtual module provided by vite-plugin-pwa at build time
    const { registerSW } = await import("virtual:pwa-register");
    registerSW({ immediate: true });
  } catch (error) {
    console.warn("[PWA] Registration failed:", error);
  }
}
